function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable func-names */

/* eslint-disable radix */

/* eslint-disable no-underscore-dangle */
import React, { useImperativeHandle, useRef, useState, useEffect, useMemo } from 'react';
import { Document, Page } from 'react-pdf';
import _ from 'lodash';
import { Spin, Icon } from 'mkui-fd';
import PropTypes from 'prop-types';
import { registerEvent, preventDefaultEvent, downloadFromLink, openPdf } from '../utils';
import { TRANSFORM } from '../constant';
var pdfjsWorker = import('pdfjs-dist/build/pdf.worker.entry');
var Viewer = React.forwardRef(function (props, ref) {
  var img = props.img,
      prefixCls = props.prefixCls;
  /** data */

  var url = img.url,
      type = img.type,
      downloadUrl = img.downloadUrl;
  var bgRef = useRef(null);
  var imgRef = useRef(null);
  var contentRef = useRef(null);
  var prevTransform = useRef({
    prevLeft: 0,
    prevTop: 0
  });

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      pdfWidth = _useState4[0],
      setPdfWidth = _useState4[1];

  var _useState5 = useState(_objectSpread({}, TRANSFORM.INIT_STATE)),
      _useState6 = _slicedToArray(_useState5, 2),
      transform = _useState6[0],
      setTransform = _useState6[1];

  var left = transform.left,
      top = transform.top,
      scale = transform.scale,
      rotate = transform.rotate;
  /**
   * @description: 鼠标滚轮缩放图片
   */

  useEffect(function () {
    registerEvent(bgRef.current, 'mousewheel', _.throttle(function (e) {
      var ev = preventDefaultEvent(e);
      var isZoomin = ev.detail ? ev.detail < 0 : ev.wheelDelta > 0;
      changeZoom(isZoomin);
    }, 100));
    return function () {
      if (bgRef.current) {
        bgRef.current.onmousewheel = null;
      }
    };
  }, [bgRef]);
  /**
   * @description: pdf预览 canvas宽
   */

  useEffect(function () {
    var clientWidth = contentRef.current.clientWidth;
    setPdfWidth(clientWidth);
  }, [contentRef]);
  /**
   * @description: 鼠标拖拽移动图片
   */

  useEffect(function () {
    if (imgRef.current && bgRef.current) {
      imgRef.current.onmousedown = function (ev) {
        ev.preventDefault();

        bgRef.current.onmousemove = function (e) {
          e.preventDefault();
          var x = e.clientX - ev.clientX;
          var y = e.clientY - ev.clientY;
          var _prevTransform$curren = prevTransform.current,
              prevLeft = _prevTransform$curren.prevLeft,
              prevTop = _prevTransform$curren.prevTop;
          setTransform(function (prev) {
            return _objectSpread({}, prev, {
              left: x + prevLeft,
              top: y + prevTop
            });
          });
        };

        bgRef.current.onmouseleave = function () {
          bgRef.current.onmousemove = null;
          bgRef.current.onmouseup = null;
        };

        bgRef.current.onmouseup = function () {
          var translates = window.getComputedStyle(imgRef.current, null).transform;
          var translateX = parseFloat(translates.substring(7, translates.length - 1).split(',')[4]);
          var translateY = parseFloat(translates.substring(7, translates.length - 1).split(',')[5]);
          prevTransform.current = {
            prevLeft: translateX,
            prevTop: translateY
          };
          bgRef.current.onmousemove = null;
          bgRef.current.onmouseup = null;
        };
      };
    }

    return function () {
      if (imgRef.current) {
        imgRef.current.onmousedown = null;
      }
    };
  }, [bgRef.current, imgRef.current]);
  /**
   * @description: 切换图片时恢复初始状态
   */

  useEffect(function () {
    setTransform(_objectSpread({}, TRANSFORM.INIT_STATE));
  }, [imgRef.current, url]);

  var changeZoom = function changeZoom(actionType) {
    var isZoomin = actionType === 'zoomin'; // 临界判断

    if (scale < TRANSFORM.MIN_SCALE_RATE && !isZoomin || scale > TRANSFORM.MAX_SCALE_RATE && isZoomin) {
      return;
    }

    var newScale = isZoomin ? scale * TRANSFORM.SCALE_RATE : scale / TRANSFORM.SCALE_RATE;
    setTransform(function (prev) {
      return _objectSpread({}, prev, {
        scale: newScale
      });
    });
  };

  var changeRotate = function changeRotate(actionType) {
    var isClockwise = actionType === 'clockwise';
    var newRotate = isClockwise ? rotate + TRANSFORM.ROTATE_DEG : rotate - TRANSFORM.ROTATE_DEG;
    setTransform(function (prev) {
      return _objectSpread({}, prev, {
        rotate: newRotate
      });
    });
  };

  useImperativeHandle(ref, function () {
    return {
      changeZoom: changeZoom,
      changeRotate: changeRotate,
      onDownload: function onDownload() {
        downloadFromLink(downloadUrl || url);
      }
    };
  }, [rotate, scale, url, ref, downloadUrl]);

  var onDocumentLoadSuccess = function onDocumentLoadSuccess() {};

  var content = useMemo(function () {
    var imageStyle = {
      transform: "translate(".concat(left, "px,").concat(top, "px) rotate(").concat(rotate, "deg) scale(").concat(scale, ")")
    };

    switch (type) {
      case 'img':
        return React.createElement("img", {
          style: imageStyle,
          className: "".concat(prefixCls, "-warpper-background-img") // key={url}
          ,
          ref: imgRef,
          src: url,
          onLoad: function onLoad() {
            setLoading(false);
          },
          alt: ""
        });

      case 'pdf':
        return React.createElement("div", {
          className: "".concat(prefixCls, "-warpper-pdf")
        }, React.createElement(Document, {
          file: url,
          onLoadSuccess: onDocumentLoadSuccess,
          onClick: function onClick() {
            openPdf(url, true, true);
          },
          options: {
            cMapUrl: 'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/',
            cMapPacked: true
          },
          workerSrc: pdfjsWorker
        }, React.createElement(Page, {
          pageNumber: 1,
          width: pdfWidth
        })));

      case 'none':
        return React.createElement("div", {
          className: "".concat(prefixCls, "-warpper-background-no")
        }, React.createElement("div", {
          className: "".concat(prefixCls, "-warpper-background-no-title")
        }, "\u6682\u65E0\u56FE\u7247"));

      default:
        break;
    }
  }, [type, url, scale, rotate, left, top]);
  return React.createElement("div", {
    className: prefixCls,
    ref: contentRef
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-warpper")
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-warpper-background"),
    ref: bgRef
  }, content, loading && type === 'img' && React.createElement(Spin, {
    className: "image-spin",
    size: "large"
  }))));
});
Viewer.propTypes = {
  img: PropTypes.object,
  prefixCls: PropTypes.string
};
Viewer.defaultProps = {
  img: {},
  prefixCls: 'mkui-image-viewer-content'
};
export default Viewer;
//# sourceMappingURL=Viewer.js.map
